// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1VYxa","productName":"Table_productName__1ukBO"};